<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Cargar horas presupuestadas</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <input cdkFocusInitial type="number" matInput placeholder="Horas presupuestadas" formControlName="budgetTime">
            <mat-error *ngIf="f.physician.errors && f.physician.errors.required">
                Dato requerido
            </mat-error>
        </mat-form-field>

    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button [disabled]="loading" mat-button type="submit">Guardar</button>
            <button [disabled]="loading" mat-button type="button" (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>